// eslint-disable-next-line custom/no-restricted-imports -- Most ez kell.
import { getFullDate } from '@common/DateTime/utils/getFullDate'
import { is } from '@common/is/is'

import postMessageHandler from '@apps/postMessageHandler/postMessageHandler'
import getWindow from '@apps/postMessageHandler/utils/getWindow'

import globals from '../../globals'
import { EAppPostMessageCommand } from '../../definitions'

import getGameInfos from './getGameInfos'

/**
 * Adat küldése a StatService-nek.
 * @param e - A hibaesemény.
 */
export default async function handleError (e: ErrorEvent | PromiseRejectionEvent): Promise<void> {
  const [
    { default: getNormalizedError },
    { default: StatService }
  ] = await Promise.all([
    import(
      /* webpackChunkName: "getNormalizedError" */
      '@common/onError/client/getNormalizedError'
    ),
    import(
      /* webpackChunkName: "StatService" */
      '@statService/client/web/StatService'
    )
  ])

  const error = is.instanceOf(e, ErrorEvent) ? e.error : e.reason
  const normalizedError = getNormalizedError(error)

  const { message, stack } = normalizedError

  // Cordovában az ismeretlen hiba miatt nem lockoljuk a játékot -- 2025.04.23.
  // A Millenárisra szánt eszközök miatt. Android 12 alatt törik az app,
  // ha visszanavigálunk a nativ backButton-nal.
  if (!globals.isCordova || message !== '?') {
    // Ez azért kell, hogy a CSS-ben tudjuk kezelni az error eseményt és kirakjunk valami értesítőt.
    document.querySelector('html')?.classList.add('error')
  }

  const gameInfos = getGameInfos()

  const fullDate = getFullDate()
  const url      = window.location.href
  const ug       = window.navigator.userAgent

  const finalNormalizedError = {
    ...normalizedError,
    message: `[${ fullDate }][${ ug }][${ url }] ${ message }`,
    stack: is.empty(gameInfos)
      ? stack
      : [ gameInfos, ...stack ]
  } as const

  /* eslint-disable no-console */
  console.log('[runtimeErrorCatcher] - original error', error)
  console.log('[runtimeErrorCatcher] - normalized error', finalNormalizedError)
  /* eslint-enable no-console */

  StatService.sendRuntimeError(globals.serial, finalNormalizedError)

  // Továbbítjuk a beágyazónak a hibát, mert a runtime errort az nem kapja el, csak a konzolon látjuk.
  postMessageHandler.emit(EAppPostMessageCommand.Error, finalNormalizedError, getWindow())
}
